import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, InputSignal, model, ModelSignal, TemplateRef } from '@angular/core';
import { IconComponent } from '@libs/components/icons';
import { ExpanderContentComponent } from './expander-content';
import { ExpanderHeaderBaseComponent } from './expander-header-base';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-expander',
  styleUrl: './expander.component.scss',
  templateUrl: './expander.component.html',
  imports: [
    IconComponent,
    ExpanderContentComponent,
    ExpanderHeaderBaseComponent,
    NgTemplateOutlet,
  ],
})

export class ExpanderComponent {
  public expanded: ModelSignal<boolean> = model(true);
  public title: InputSignal<string> = input.required();
  public badge: InputSignal<number | undefined> = input();
  public headerTemplate: InputSignal<TemplateRef<unknown> | undefined> = input();
}
